export { default } from "./useContentAttachmentsGet";
